<template>
    <div class="ColorPicker">
        <div class="ColorPicker__container">
            <div class="ColorPicker__button" :class="{ 'disable': color == 'white' || color == null || color == 'grey' }" @click="resetColor()">Effacer</div>
            <div class="ColorPicker__items">    
                <Button class="ColorPicker__item" 
                :class="[ is_color, { 'selected' : color == is_color } ]" 
                v-for="(is_color, i) in colors" 
                @click="onClick(is_color)"
                :key="i"/>
            </div>
        </div>
    </div>
</template>
<script>

import { Categories } from '../js/Categories.js'

export default {

    name: 'ColorPicker',
    data: ()=>({
        ready: false,
        colors: []
    }),
    computed: { 
        categorie() { return this.$store.getters['app/categorie'] },
        color() { return this.$store.getters['app/color'] },
    },
    mounted() {
        const indice = (this.categorie == 'silhouettes') ? 1 : 2
        _.each(Categories[indice]['colors'], (color)=>{
            this.colors.push(color)
        })
    },
    methods: {
        onClick(color) {
            this.$store.commit('app/SET_AMBIANCE', 'click')
            this.$store.commit('app/SET_COLOR', color)
        },
        resetColor() {
            this.$store.commit('app/RESET_COLOR') 
            this.$store.commit('app/SET_COLOR', null)
        },
    },
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.ColorPicker
    position absolute
    width 100%
    height 60px
    bottom 50px

    &__container
        display flex
        flex-direction row
        justify-content space-between
        padding 0 24px

    &__button 
        height 30px
        background white
        color black
        font-size 16px
        border-radius 15px
        width 80px
        text-align center
        cursor pointer
        border 3px solid white
        line-height 25px

        &.disable
            pointer-events none 
            opacity .25

    &__items
        display flex
        flex-direction row

    &__item
        width 30px
        height 30px
        border-radius 50%
        background white
        margin 0 4px
        cursor pointer
        border 3px solid white

        &.dark_brown 
            background asset_dark_brown
            border 3px solid asset_dark_brown
        &.brown 
            background asset_brown
            border 3px solid asset_brown
        &.red 
            background asset_red
            border 3px solid asset_red
        &.green 
            background asset_green
            border 3px solid asset_green
        &.dark_blue 
            background asset_dark_blue
            border 3px solid asset_dark_blue
        &.orange 
            background asset_orange
            border 3px solid asset_orange
        &.purple 
            background asset_purple
            border 3px solid asset_purple
        &.yellow 
            background asset_yellow
            border 3px solid asset_yellow
        &.blue 
            background asset_blue
            border 3px solid asset_blue
        &.pink 
            background asset_pink
            border 3px solid asset_pink
        &.skin_1 
            background skin_1
            border 3px solid skin_1
        &.skin_2 
            background skin_2
            border 3px solid skin_2
        &.skin_3 
            background skin_3
            border 3px solid skin_3
        &.skin_4 
            background skin_4
            border 3px solid skin_4
        &.skin_5 
            background skin_5
            border 3px solid skin_5
        &.skin_6 
            background skin_6
            border 3px solid skin_6
        &.skin_7 
            background skin_7
            border 3px solid skin_7
        &.skin_8 
            background skin_8
            border 3px solid skin_8
        &.skin_9 
            background skin_9
            border 3px solid skin_9

        &.selected
            border 3px solid white

</style>































































// WEBPACK FOOTER //
// src/components/defis/components/ColorPicker.vue